import * as React from 'react'

export type HeadProps = React.ComponentPropsWithoutRef<'thead'>
export const Head = (props: HeadProps) => <thead {...props} />
